import { render, staticRenderFns } from "./machineCheckDetail.vue?vue&type=template&id=0c21b3bc&scoped=true&"
import script from "./machineCheckDetail.vue?vue&type=script&lang=js&"
export * from "./machineCheckDetail.vue?vue&type=script&lang=js&"
import style0 from "./machineCheckDetail.vue?vue&type=style&index=0&id=0c21b3bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21b3bc",
  null
  
)

export default component.exports